<template lang="pug">
div.body-ch-avt
  div.modal-header
    span.ch-avt-modal-title {{title}}
    span.ch-avt-modal-btn-close.material-icons(@click="$emit('close')") close
  div.modal-body
    //- p.ch-avt-content Nhập email đã đăng ký của bạn để nhận lại mật khẩu mới qua email:
    form
      .row
        .col-md-12.box-choose-file
          label.control-label Nhập hình hiển thị
          input(id="avt" name="avt" type="file" accept="image/*" @change="onFileChange")
      //- .row
      //-   .col-md-12(v-if="icon")
      //-     .form-group.ch-avt-email(:class='errorArray')
      //-       label.control-label Nhập hình hiển thị
      //-       input#email.form-control(type="text" name="avatar" placeholder="..." required autofocus v-model="icon" disabled)
  div.modal-footer.ch-avt-custom-footer
    div.row
      div.col-md-6.col-12
        div.text-right
          a.ch-avt-btn-continue.btn(@click='validateChange()') Cập nhật
      div.col-md-6.col-12
        div.text-left
          a.ch-avt-btn-back.btn(@click="$emit('close')") Hủy
</template>
<script>
// import firebase from 'firebase'
export default {
  props: {
    title: String,
    user: Object,
    saveFunction: Function
  },
  data () {
    return {
      icon: this.user.avatar,
      errorArray: [],
      lstAvt: []
    }
  },
  methods: {
    onFileChange(e) {
      let files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      for (let i = 0; i < files.length; i++) {
        let obj = {'name': files[i].name, 'file': files[i], 'src': URL.createObjectURL(files[i])}
        this.lstAvt.push(obj)
      }
    },
    validateChange() {
      if (this.lstAvt && this.lstAvt.length > 0) {
        this.saveFunction({id: this.user.id, avatar: this.icon, lstAvt: this.lstAvt})
        this.$nextTick(() => {
          this.$emit('close')
        })
      } else {
        // console.log('Lỗi rồi')
        this.errorArray = ['is-empty has-error']
      }
    }
  }
}
</script>
<style lang="scss">
:root {
  // Color 
  --color-background-button: #FFD311;
}
.body-ch-avt {
  margin-left: 20px;
  margin-right: 20px;
  background-color: white;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 5px;
  font-family: 'adobe-clean', sans-serif;
  .ch-avt-modal-title {
    float: left;
    font-size: 17px;
  }
  .ch-avt-modal-btn-close {
    float: right;
    &:hover {
      cursor: pointer;
    }
  }
  .ch-avt-body-title {
    color: var(--color-type-selected);
    margin-bottom: 0;
    padding-bottom: 3px;
  }
  .ch-avt-content {
    margin-bottom: 15px;
    font-size: 15px;
  }
  .box-choose-file {
    height: 40px;
  }
  .ch-avt-email {
    margin-top: 0px; 
    margin-bottom: 0px; 
  }
  .ch-avt-btn-continue {
    background: var(--color-background-button);
    color:black;
    text-transform: none;
    font-size: 13px;
    // font: 14px/17px Proxima Nova;
    border: 1px solid #FFD311;
    border-radius: 5px;
    // box-shadow: 0px 0px 0px;
    width: 160px;
    margin-top: 0 !important;
    margin-bottom: 20px;
  }
  .ch-avt-btn-back {
    background: white;
    color: black;
    text-transform: none;
    font-size: 13px;
    // font: 14px/17px Proxima Nova;
    border: 1px solid #FFD311;
    border-radius: 5px;
    // box-shadow: 0px 0px 0px;
    width: 160px;
    margin-top: 0 !important;
  }
  .ch-avt-custom-footer {
    padding: 0;
    border: 0;
  }

// cellphones
@media (max-width: 414px) {
  .ch-avt-email {
    margin-bottom: -10px
  }
  .ch-avt-btn-continue {
    float: left;
    margin-left: 40px;
    width: 115px;
    padding: 12px;
    margin-top: 0px;
  }
  .ch-avt-btn-back {
    float: right;
    margin-right: 40px;
    width: 115px;
    margin-top: 0px;
  }
}
}
</style>



// WEBPACK FOOTER //
// changeAvatar.vue?539a5730